import {
  IsBoolean,
  IsDateString,
  IsNotEmpty,
  IsOptional,
  IsNumber,
  IsString,
} from 'class-validator';

type OrgstructureApproveType =
  | 'direct'
  | 'legal'
  | 'operational'
  | 'functional';

export class VacationApprover {
  @IsDateString()
  @IsNotEmpty()
  deadline: string;

  @IsString()
  @IsOptional()
  managerApproval?: string;

  @IsString()
  @IsNotEmpty()
  approvalType: string;

  @IsString()
  @IsOptional()
  orgstructureType: OrgstructureApproveType;

  @IsString()
  @IsOptional()
  groupName?: string;

  @IsNumber()
  @IsOptional()
  managerApproveLevels: number;

  @IsBoolean()
  @IsOptional()
  orgstructureApprove?: boolean;

  @IsString()
  @IsNotEmpty()
  canEdit: string;
}
